export function formDataFromParams(params) {
  const data = new FormData();
  Object.keys(params).forEach((key) => {
    data.set(key, params[key]);
  });
  return data;
}
